import ServicePage from '../servicePage/ServicePage';
import { businessAutomationServiceData } from '../../data/businessAutomationServiceData';

const BusinessAutomationPage = () => {
  return <ServicePage serviceData={businessAutomationServiceData} />;
};

export default BusinessAutomationPage;